import { AuthorityStatus } from './CalendarModels';
import { OptionSet } from './OptionSet';
import { StudentSchedule } from './StudentSchedule';

export class Schedule_ep {
    /**
     *
     */

    constructor() { }
    // constructor(studentSchedule?:StudentSchedule){
    //     this.Sunday_e = studentSchedule.Sunday_e;
    //     this.Sunday_p = studentSchedule.Sunday_p;
    //     this.Monday_e = studentSchedule.Monday_e;
    //     this.Monday_p = studentSchedule.Monday_p;
    //     this.Tuesday_e = studentSchedule.Tuesday_e;
    //     this.Tuesday_p = studentSchedule.Tuesday_p;
    //     this.Wednesday_e = studentSchedule.Wednesday_e;
    //     this.Wednesday_p = studentSchedule.Wednesday_p;
    //     this.Thursday_e = studentSchedule.Thursday_e;
    //     this.Thursday_p = studentSchedule.Thursday_p;
    //     this.Friday_e = studentSchedule.Friday_e;
    //     this.Friday_p = studentSchedule.Friday_p;
    //     this.Remarks = studentSchedule.Remarks;
    // }


    public Year: string;
    public Class: OptionSet;
    public ClassCode: OptionSet;
    public Classification: OptionSet;
    public Period: OptionSet;
    public ScheduleType: OptionSet;
    public FromDate: string;
    public ToDate: string;
    public Remarks: string;
    public Status: string;
    public StatusReason: string;
    public studentCount: number;
    public AuthorityStatuses?: AuthorityStatus[];

    //איסוף
    public Id_e: string;
    public Sunday_e: OptionSet;
    public Monday_e: OptionSet;
    public Tuesday_e: OptionSet;
    public Wednesday_e: OptionSet;
    public Thursday_e: OptionSet;
    public Friday_e: OptionSet;
    public Saturday_e: OptionSet;

    //פיזור
    public Id_p: string;
    public Sunday_p: OptionSet;
    public Monday_p: OptionSet;
    public Tuesday_p: OptionSet;
    public Wednesday_p: OptionSet;
    public Thursday_p: OptionSet;
    public Friday_p: OptionSet;
    public Saturday_p: OptionSet;
}

export class GeneralSchedule {
    mainSchedule: Schedule_ep;
    Tzaharon: Schedule_ep;
}

